module.exports = __webpack_public_path__ + "img/icon-payment-creditcard.e7acdc30.png";